// src/components/ProgressBar.js

import React from "react";
import "./ProgressBar.css";

function ProgressBar({ currentStep, totalSteps }) {
  const progressPercentage = (currentStep / (totalSteps + 1)) * 100;

  return (
    <>
      <div className="progress-bar">
        <p
          className="progress-step"
          style={{ width: `${progressPercentage - 8}%` }}
        >
          {currentStep <= 9 ? "0".concat(currentStep) : currentStep}
        </p>
        <div
          className="progress"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
    </>
  );
}

export default ProgressBar;
